module.exports = __webpack_public_path__ + "assets/phone-account.1632aad0.svg";